import React from "react";
import { Button, Popover, List } from "devextreme-react";

const SelectItem = (props) => (
  <div className="tipo-denuncias-select-item">
    { props.Icon && props.Icon.length === 1 && (
      <i className="achs-icon-main-filter">{props.Icon ? props.Icon : "S" }</i>
    )}
    { props.Icon && props.Icon.length > 1 && (
      <i className="material-icons">{props.Icon}</i>
    )}

    <span>{props.name}</span>
  </div>
);


class SelectTipo extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      selected: props.selected,
    };
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.selected && prevProps.selected) {
      if (prevProps.selected.name !== this.props.selected.name) this.setState({ selected: this.props.selected });
    } else if (this.props.selected) {
      this.setState({ selected: this.props.selected });
    }
  }

  handleOpenClose = (open) => this.setState({ open });

  handleSelect = (e) => {
    this.setState({ selected: e.itemData, open: false });
    this.props.onClick(e.itemData);
  }

  render() {
    
    return (
      <React.Fragment >
        <div className="tipo-denuncias-select">
          {this.state.selected.Icon != null && this.state.selected.Icon.length === 1 && (<i className="achs-icon-main-filter">{this.state.selected.Icon}</i>)}
          {this.state.selected.Icon != null && this.state.selected.Icon.length > 1 && (<i className="material-icons">{this.state.selected.Icon}</i>)}
          <span>{this.state.selected.name}</span>

          <Button
            className="denuncias-select-button"
            id="buttonSelect"
            height={25}
            onClick={() => this.handleOpenClose(true)}
          >
            <i className="material-icons">keyboard_arrow_down</i>
          </Button>
        </div>
        <Popover
          onHiding={() => this.handleOpenClose(false)}
          closeOnOutsideClick
          position={{ offset: "20 16", my: "right top" }}
          target="#buttonSelect"
          className="select-type-popover"
          width={270}
          visible={this.state.open}
        >
          <div>
            <List
              selectionMode="none"
              className="denuncias-select-list"
              onItemClick={this.handleSelect}
              items={this.props.items}
              itemComponent={(props) => <SelectItem {...props} />}
            />

          </div>
        </Popover>
      </React.Fragment>
    );
  }
}

export default SelectTipo;
